import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './styles/ConnectDiscover.css';

export default function ConnectDiscover() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [showMobileNav, setShowMobileNav] = useState(false);

  // Mock users data
  const [users, setUsers] = useState([
    {
      id: 1,
      fullName: 'Alex Rivera',
      pronouns: 'they/them',
      genderIdentity: 'Non-binary',
      sexualOrientation: 'Queer',
      location: 'San Juan, Puerto Rico',
      bio: 'Caribbean native exploring my own backyard. Love connecting travelers with hidden gems and local LGBTQ+ friendly spots.',
      travelStyle: 'Cultural Immersion',
      favoriteDestinations: ['Puerto Rico', 'Dominican Republic', 'Cuba'],
      isFollowing: false,
      followers: 234,
      following: 156,
      isLocalGuide: true,
      posts: [
        { id: 1, content: 'Just finished a walking tour of Old San Juan with some amazing travelers! 🏛️', image: 'https://images.unsplash.com/photo-1579687196544-08ae57ab5960?w=800', likes: 45, comments: 12, timestamp: Date.now() - 1000 * 60 * 60 * 3 },
        { id: 2, content: 'The bioluminescent bay in Vieques is a must-see! One of nature\'s most magical experiences ✨', image: null, likes: 67, comments: 18, timestamp: Date.now() - 1000 * 60 * 60 * 24 * 2 }
      ]
    },
    {
      id: 2,
      fullName: 'Jordan Chen',
      pronouns: 'she/her',
      genderIdentity: 'Transgender Woman',
      sexualOrientation: 'Lesbian',
      location: 'Toronto, Canada',
      bio: 'Travel blogger and photographer. Documenting safe spaces for trans travelers across the Caribbean islands.',
      travelStyle: 'Solo Adventurer',
      favoriteDestinations: ['Aruba', 'Curaçao', 'St. Lucia'],
      isFollowing: true,
      followers: 1205,
      following: 342,
      isLocalGuide: false,
      posts: [
        { id: 1, content: 'Documenting my journey through the ABC islands. Curaçao has been incredibly welcoming! 🌈', image: 'https://images.unsplash.com/photo-1568402102990-bc541580b59f?w=800', likes: 156, comments: 34, timestamp: Date.now() - 1000 * 60 * 60 * 5 },
        { id: 2, content: 'Found this hidden gem of a café in Willemstad. The owner is an ally and the coffee is amazing ☕', image: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800', likes: 89, comments: 21, timestamp: Date.now() - 1000 * 60 * 60 * 24 }
      ]
    },
    {
      id: 3,
      fullName: 'Sam Williams',
      pronouns: 'he/him',
      genderIdentity: 'Cisgender Man',
      sexualOrientation: 'Gay',
      location: 'Bridgetown, Barbados',
      bio: 'Local guide in Barbados. Here to help you discover the best beaches, restaurants, and nightlife!',
      travelStyle: 'Beach & Relaxation',
      favoriteDestinations: ['Barbados', 'Trinidad', 'Grenada'],
      isFollowing: false,
      followers: 567,
      following: 123,
      isLocalGuide: true,
      posts: [
        { id: 1, content: 'Sunset at Carlisle Bay never gets old 🌅 Who\'s visiting Barbados soon?', image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800', likes: 78, comments: 15, timestamp: Date.now() - 1000 * 60 * 60 * 8 },
        { id: 2, content: 'Just hosted a group of travelers for a local food tour. Rum punch and flying fish for everyone! 🐟', image: null, likes: 45, comments: 9, timestamp: Date.now() - 1000 * 60 * 60 * 24 * 3 }
      ]
    },
    {
      id: 4,
      fullName: 'Maya Thompson',
      pronouns: 'she/they',
      genderIdentity: 'Genderfluid',
      sexualOrientation: 'Bisexual',
      location: 'Miami, USA',
      bio: 'Cruise enthusiast and island hopper. Always planning my next Caribbean adventure!',
      travelStyle: 'Luxury Seeker',
      favoriteDestinations: ['Bahamas', 'Jamaica', 'Cayman Islands'],
      isFollowing: false,
      followers: 892,
      following: 445,
      isLocalGuide: false,
      posts: [
        { id: 1, content: 'Cruise life is the best life! Just docked in Nassau 🚢', image: 'https://images.unsplash.com/photo-1548574505-5e239809ee19?w=800', likes: 112, comments: 28, timestamp: Date.now() - 1000 * 60 * 60 * 12 },
        { id: 2, content: 'The private island experience in the Bahamas was everything! Highly recommend 🏝️', image: 'https://images.unsplash.com/photo-1559128010-7c1ad6e1b6a5?w=800', likes: 203, comments: 45, timestamp: Date.now() - 1000 * 60 * 60 * 24 * 4 }
      ]
    },
    {
      id: 5,
      fullName: 'Chris Martinez',
      pronouns: 'he/him',
      genderIdentity: 'Cisgender Man',
      sexualOrientation: 'Gay',
      location: 'Willemstad, Curaçao',
      bio: 'Born and raised in Curaçao. Ask me anything about the ABC islands!',
      travelStyle: 'Nightlife & Parties',
      favoriteDestinations: ['Curaçao', 'Aruba', 'Bonaire'],
      isFollowing: true,
      followers: 445,
      following: 267,
      isLocalGuide: true,
      posts: [
        { id: 1, content: 'Pride month in Curaçao was incredible! So proud of our community 🏳️‍🌈', image: 'https://images.unsplash.com/photo-1620735692151-26a7e0748f53?w=800', likes: 234, comments: 56, timestamp: Date.now() - 1000 * 60 * 60 * 24 },
        { id: 2, content: 'Best nightlife spots in Willemstad - DM me for the insider guide! 🎉', image: null, likes: 67, comments: 23, timestamp: Date.now() - 1000 * 60 * 60 * 24 * 5 }
      ]
    },
    {
      id: 6,
      fullName: 'Taylor Brooks',
      pronouns: 'they/them',
      genderIdentity: 'Agender',
      sexualOrientation: 'Pansexual',
      location: 'London, UK',
      bio: 'Digital nomad working remotely from Caribbean beaches. Looking for co-working buddies!',
      travelStyle: 'Budget Backpacker',
      favoriteDestinations: ['Dominican Republic', 'Puerto Rico', 'Martinique'],
      isFollowing: false,
      followers: 321,
      following: 189,
      isLocalGuide: false,
      posts: [
        { id: 1, content: 'Working from a beach café in Punta Cana. Living the dream! 💻🌴', image: 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800', likes: 89, comments: 19, timestamp: Date.now() - 1000 * 60 * 60 * 6 },
        { id: 2, content: 'Looking for co-working buddies in Puerto Rico next month. Anyone interested?', image: null, likes: 34, comments: 12, timestamp: Date.now() - 1000 * 60 * 60 * 24 * 2 }
      ]
    },
    {
      id: 7,
      fullName: 'Jamie Lee',
      pronouns: 'she/her',
      genderIdentity: 'Cisgender Woman',
      sexualOrientation: 'Lesbian',
      location: 'Kingston, Jamaica',
      bio: 'Jamaican local sharing the real Jamaica beyond the resorts. LGBTQ+ ally and advocate.',
      travelStyle: 'Cultural Immersion',
      favoriteDestinations: ['Jamaica', 'Haiti', 'Cuba'],
      isFollowing: false,
      followers: 678,
      following: 234,
      isLocalGuide: true,
      posts: [
        { id: 1, content: 'Sharing the real Jamaica with visitors who want authentic experiences 🇯🇲', image: 'https://images.unsplash.com/photo-1570789210967-2cac24e2beee?w=800', likes: 123, comments: 31, timestamp: Date.now() - 1000 * 60 * 60 * 10 },
        { id: 2, content: 'Blue Mountain coffee tour was a hit today! Nothing beats Jamaican coffee ☕', image: 'https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=800', likes: 78, comments: 14, timestamp: Date.now() - 1000 * 60 * 60 * 24 * 6 }
      ]
    },
    {
      id: 8,
      fullName: 'Morgan Davis',
      pronouns: 'he/they',
      genderIdentity: 'Genderqueer',
      sexualOrientation: 'Queer',
      location: 'New York, USA',
      bio: 'Wellness retreat seeker. Finding peace and acceptance in Caribbean spirituality.',
      travelStyle: 'Nature & Outdoors',
      favoriteDestinations: ['St. Lucia', 'Dominica', 'Grenada'],
      isFollowing: false,
      followers: 234,
      following: 156,
      isLocalGuide: false,
      posts: [
        { id: 1, content: 'Found inner peace at a yoga retreat in St. Lucia. The Pitons are breathtaking 🧘‍♂️', image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800', likes: 145, comments: 38, timestamp: Date.now() - 1000 * 60 * 60 * 4 },
        { id: 2, content: 'Dominica\'s hot springs are healing for body and soul. Highly recommend for wellness travelers 🌿', image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800', likes: 98, comments: 22, timestamp: Date.now() - 1000 * 60 * 60 * 24 * 3 }
      ]
    }
  ]);

  const filters = [
    { id: 'all', label: 'All' },
    { id: 'local-guides', label: 'Local Guides' },
    { id: 'travelers', label: 'Travelers' },
    { id: 'following', label: 'Following' }
  ];

  const formatTimeAgo = (timestamp) => {
    const diff = Date.now() - timestamp;
    const minutes = Math.floor(diff / (1000 * 60));
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    if (days < 7) return `${days}d ago`;
    return new Date(timestamp).toLocaleDateString();
  };

  useEffect(() => {
    const storedUser = localStorage.getItem('connectUser');
    if (!storedUser) {
      navigate('/connect');
      return;
    }
    setUser(JSON.parse(storedUser));

    // Load following state from localStorage
    const storedFollowing = localStorage.getItem('connectFollowing');
    if (storedFollowing) {
      const followingIds = JSON.parse(storedFollowing);
      setUsers(prev => prev.map(u => ({
        ...u,
        isFollowing: followingIds.includes(u.id)
      })));
    }
  }, [navigate]);

  const handleFollow = (userId) => {
    setUsers(prev => {
      const updated = prev.map(u => {
        if (u.id === userId) {
          return {
            ...u,
            isFollowing: !u.isFollowing,
            followers: u.isFollowing ? u.followers - 1 : u.followers + 1
          };
        }
        return u;
      });

      // Save to localStorage
      const followingIds = updated.filter(u => u.isFollowing).map(u => u.id);
      localStorage.setItem('connectFollowing', JSON.stringify(followingIds));

      return updated;
    });

    // Update selected profile if open
    if (selectedProfile?.id === userId) {
      setSelectedProfile(prev => ({
        ...prev,
        isFollowing: !prev.isFollowing,
        followers: prev.isFollowing ? prev.followers - 1 : prev.followers + 1
      }));
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('connectUser');
    navigate('/connect');
  };

  const filteredUsers = users.filter(u => {
    // Search filter
    const matchesSearch = searchQuery === '' || 
      u.fullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      u.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
      u.bio.toLowerCase().includes(searchQuery.toLowerCase()) ||
      u.favoriteDestinations.some(d => d.toLowerCase().includes(searchQuery.toLowerCase()));

    // Category filter
    let matchesFilter = true;
    if (activeFilter === 'local-guides') {
      matchesFilter = u.isLocalGuide;
    } else if (activeFilter === 'travelers') {
      matchesFilter = !u.isLocalGuide;
    } else if (activeFilter === 'following') {
      matchesFilter = u.isFollowing;
    }

    return matchesSearch && matchesFilter;
  });

  if (!user) return null;

  return (
    <div className="connect-discover-page">
      {/* Header */}
      <header className="connect-profile-header">
        <Link to="/" className="connect-profile-logo">
          <img src={process.env.PUBLIC_URL + '/assets/logo.png'} alt="OutCaribbean" />
        </Link>
        <nav className="connect-profile-nav">
          <Link to="/connect/profile" className="connect-nav-link">Profile</Link>
          <Link to="/connect/discover" className="connect-nav-link active">Discover</Link>
          <Link to="/connect/messages" className="connect-nav-link">Messages</Link>
        </nav>
        <button className="connect-logout-btn" onClick={handleLogout}>
          Log Out
        </button>
        <button className="connect-mobile-nav-toggle" onClick={() => setShowMobileNav(true)}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </header>

      {/* Mobile Navigation */}
      {showMobileNav && (
        <>
          <div className="connect-mobile-nav-overlay active" onClick={() => setShowMobileNav(false)}></div>
          <div className="connect-mobile-nav-menu active">
            <div className="connect-mobile-nav-header">
              <h3>Menu</h3>
              <button className="connect-mobile-nav-close" onClick={() => setShowMobileNav(false)}>×</button>
            </div>
            <div className="connect-mobile-nav-links">
              <Link to="/connect/profile" className="connect-nav-link" onClick={() => setShowMobileNav(false)}>Profile</Link>
              <Link to="/connect/discover" className="connect-nav-link active" onClick={() => setShowMobileNav(false)}>Discover</Link>
              <Link to="/connect/messages" className="connect-nav-link" onClick={() => setShowMobileNav(false)}>Messages</Link>
            </div>
            <div className="connect-mobile-nav-footer">
              <button className="connect-logout-btn" onClick={handleLogout}>Log Out</button>
            </div>
          </div>
        </>
      )}

      {/* Main Content */}
      <main className="connect-discover-main">
        {/* Search & Filters */}
        <div className="connect-discover-header">
          <h1>Discover People</h1>
          <p>Connect with LGBTQ+ travelers and local guides across the Caribbean</p>

          <div className="connect-search-bar">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <input
              type="text"
              placeholder="Search by name, location, or destination..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchQuery && (
              <button className="connect-search-clear" onClick={() => setSearchQuery('')}>
                ×
              </button>
            )}
          </div>

          <div className="connect-filters">
            {filters.map(filter => (
              <button
                key={filter.id}
                className={`connect-filter-btn ${activeFilter === filter.id ? 'active' : ''}`}
                onClick={() => setActiveFilter(filter.id)}
              >
                {filter.label}
                {filter.id === 'following' && (
                  <span className="connect-filter-count">
                    {users.filter(u => u.isFollowing).length}
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Users Grid */}
        <div className="connect-users-grid">
          {filteredUsers.length > 0 ? (
            filteredUsers.map(person => (
              <div key={person.id} className="connect-user-card">
                <div className="connect-user-card-header">
                  <div className="connect-user-avatar">
                    <div className="connect-user-avatar-placeholder">
                      {person.fullName.charAt(0)}
                    </div>
                  </div>
                  {person.isLocalGuide && (
                    <span className="connect-local-guide-badge">Local Guide</span>
                  )}
                </div>

                <div className="connect-user-card-body">
                  <h3 className="connect-user-name">{person.fullName}</h3>
                  <span className="connect-user-pronouns">{person.pronouns}</span>
                  <p className="connect-user-location">📍 {person.location}</p>

                  <div className="connect-user-tags">
                    {person.genderIdentity && (
                      <span className="connect-user-tag">{person.genderIdentity}</span>
                    )}
                    {person.sexualOrientation && (
                      <span className="connect-user-tag">{person.sexualOrientation}</span>
                    )}
                  </div>

                  <p className="connect-user-bio">{person.bio}</p>

                  <div className="connect-user-destinations">
                    {person.favoriteDestinations.slice(0, 3).map(dest => (
                      <span key={dest} className="connect-dest-tag">{dest}</span>
                    ))}
                  </div>

                  <div className="connect-user-stats">
                    <span><strong>{person.followers}</strong> followers</span>
                    <span><strong>{person.following}</strong> following</span>
                  </div>
                </div>

                <div className="connect-user-card-actions">
                  <button
                    className={`connect-follow-btn ${person.isFollowing ? 'following' : ''}`}
                    onClick={() => handleFollow(person.id)}
                  >
                    {person.isFollowing ? (
                      <>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        Following
                      </>
                    ) : (
                      <>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                          <circle cx="8.5" cy="7" r="4"/>
                          <line x1="20" y1="8" x2="20" y2="14"/>
                          <line x1="23" y1="11" x2="17" y2="11"/>
                        </svg>
                        Follow
                      </>
                    )}
                  </button>
                  <button 
                    className="connect-view-btn"
                    onClick={() => setSelectedProfile(person)}
                  >
                    View Profile
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="connect-no-results">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="11" cy="11" r="8"/>
                <path d="m21 21-4.35-4.35"/>
              </svg>
              <h3>No results found</h3>
              <p>Try adjusting your search or filters</p>
            </div>
          )}
        </div>
      </main>

      {/* Profile Modal */}
      {selectedProfile && (
        <div className="connect-profile-modal-overlay" onClick={() => setSelectedProfile(null)}>
          <div className="connect-profile-modal" onClick={(e) => e.stopPropagation()}>
            <button className="connect-modal-close" onClick={() => setSelectedProfile(null)}>×</button>
            
            <div className="connect-modal-header">
              <div className="connect-modal-avatar">
                <div className="connect-modal-avatar-placeholder">
                  {selectedProfile.fullName.charAt(0)}
                </div>
              </div>
              {selectedProfile.isLocalGuide && (
                <span className="connect-local-guide-badge large">🌴 Local Guide</span>
              )}
            </div>

            <div className="connect-modal-body">
              <h2>{selectedProfile.fullName}</h2>
              <span className="connect-modal-pronouns">{selectedProfile.pronouns}</span>
              <p className="connect-modal-location">📍 {selectedProfile.location}</p>

              <div className="connect-modal-stats">
                <div className="connect-stat">
                  <strong>{selectedProfile.followers}</strong>
                  <span>Followers</span>
                </div>
                <div className="connect-stat">
                  <strong>{selectedProfile.following}</strong>
                  <span>Following</span>
                </div>
              </div>

              <div className="connect-modal-tags">
                {selectedProfile.genderIdentity && (
                  <span className="connect-modal-tag">{selectedProfile.genderIdentity}</span>
                )}
                {selectedProfile.sexualOrientation && (
                  <span className="connect-modal-tag">{selectedProfile.sexualOrientation}</span>
                )}
                {selectedProfile.travelStyle && (
                  <span className="connect-modal-tag travel">{selectedProfile.travelStyle}</span>
                )}
              </div>

              <p className="connect-modal-bio">{selectedProfile.bio}</p>

              <div className="connect-modal-section">
                <h4>Favorite Destinations</h4>
                <div className="connect-modal-destinations">
                  {selectedProfile.favoriteDestinations.map(dest => (
                    <span key={dest} className="connect-modal-dest">{dest}</span>
                  ))}
                </div>
              </div>

              {/* Posts Section */}
              {selectedProfile.posts && selectedProfile.posts.length > 0 && (
                <div className="connect-modal-section">
                  <h4>Recent Posts</h4>
                  <div className="connect-modal-posts">
                    {selectedProfile.posts.map(post => (
                      <div key={post.id} className="connect-modal-post">
                        <p className="connect-modal-post-content">{post.content}</p>
                        {post.image && (
                          <div className="connect-modal-post-image">
                            <img src={post.image} alt="Post" />
                          </div>
                        )}
                        <div className="connect-modal-post-stats">
                          <span>❤️ {post.likes}</span>
                          <span>💬 {post.comments}</span>
                          <span className="connect-modal-post-time">{formatTimeAgo(post.timestamp)}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="connect-modal-actions">
                <button
                  className={`connect-follow-btn large ${selectedProfile.isFollowing ? 'following' : ''}`}
                  onClick={() => handleFollow(selectedProfile.id)}
                >
                  {selectedProfile.isFollowing ? 'Following' : 'Follow'}
                </button>
                <Link to="/connect/messages" className="connect-message-btn">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                  </svg>
                  Message
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
